import { connect } from 'react-redux'
import { Selection } from './Selection.jsx'
import { setCollaborativeIndexationCreationZone } from '../../../../../redux/collaborativeIndexations/actions'
import { getScaledCurrentImageRect } from '../../../../../redux/canvas/selectors'
import { getRotation } from '../../../../../redux/appliedFilters/selectors'
import { computeMousePositionRelativeToImage } from '../../../../../redux/collaborativeIndexations/selectors'

export const mapStateToProps = (state, props) => ({
    imageRect: getScaledCurrentImageRect(state, props.parentId),
    rotation: getRotation(state),
    computeMousePositionRelativeToImage: mousePosition => computeMousePositionRelativeToImage(state, props.parentId, mousePosition),
})

export const mapDispatchToProps = (dispatch, ownProps) => ({
    setCollaborativeIndexationCreationZone: indexationZone => dispatch(setCollaborativeIndexationCreationZone(indexationZone, ownProps.parentId)),
})

export const SelectionContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Selection)
